<template>
  <a-select
    v-model:value="valuesSelected"
    mode="multiple"
    :showSearch="!valuesSelected?.includes('')"
    :filterOption="filterOption"
    :class="{ 'select-max-tag': valuesSelected?.includes('') }"
    :placeholder="props.placeholder"
    style="width: 100%"
    :max-tag-count="valuesSelected?.includes('') ? 0 : valuesSelected.length"
    :max-tag-placeholder="() => props.placeholderTagMax"
    @change="handleChange"
    @select="handleSelect"
    @deselect="handleDeselect"
  >
    <a-select-option
      value=""
      :disabled="valuesSelected && valuesSelected != '' && !valuesSelected.includes('')"
    >
      {{ props.placeholderTagMax }}
    </a-select-option>
    <a-select-option
      v-for="option in props.options"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    >
      {{ option.label }}
    </a-select-option>
  </a-select>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    options: Array<{ value: number | string; label: string }>;
    values: Array<string | number | undefined>;
    disabled?: boolean;
    placeholder?: string;
    placeholderTagMax?: string;
  }>(),
  {
    placeholder: "Seleccione",
    placeholderTagMax: "Todas las opciones",
  }
);

const valuesSelected = ref<Array<string | number | undefined>>([]);

const emit = defineEmits<{
  (e: "update:values", values: Array<string | number | undefined>): void;
}>();

const handleChange = (value: Array<string | number | undefined>) => {
  // si se seleccionan todos de forma individual
  if (value.length == props.options.length) {
    const values = props.options.map((option) => option.value);
    emit("update:values", values);
  } else {
    emit("update:values", value);
  }
};

const handleSelect = (value: string) => {
  // si se selecciona la opcion todos
  if (value == "") {
    const values = props.options.map((option) => option.value);
    emit("update:values", values);
  }
};

const handleDeselect = (value: string) => {
  let values: Array<string | number | undefined>;
  // si se deselecciona la opcion todos
  if (value == "") values = [];
  // si se deselecciona otra opcion
  else values = props.values.filter((item) => item != "" && item != value);
  emit("update:values", values);
};

const filterOption = (input: string, option: any) => {
  console.log(input, option);
  return option?.label?.toLowerCase().includes(input.toLowerCase());
};

// watch(
//   () => props.options,
//   () => {
//     const values = props.options.map((option) => option.value);
//     emit("update:values", values);
//   },
//   { immediate: true }
// );

watch(
  () => props.values,
  (newValues) => {
    valuesSelected.value = newValues;
    if (newValues.length == props.options.length) {
      valuesSelected.value = ["", ...valuesSelected.value];
    }
  },
  { immediate: true }
);
</script>

<style scoped lang="sass">
:global(.select-max-tag .ant-select-selection-item)
  background: none !important
  border: none !important
</style>
